module.exports = __webpack_public_path__ + "static/img/sm_6.4f1d42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_6.png
// module id = cq4c
// module chunks = 0